import { TriangleAlert } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Open AI quality flags on a photo, for a PM. Nothing when there are none. */
export function FlagBadge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null;
  const flags = count === 1 ? "flag" : "flags";
  return (
    <Badge
      variant="warning"
      data-testid="flag-badge"
      role="img"
      aria-label={`${count} quality ${flags}`}
      className={cn("gap-1 bg-background/90 shadow-sm backdrop-blur-sm", className)}
    >
      <TriangleAlert className="size-3" aria-hidden />
      {count} {flags}
    </Badge>
  );
}
